import http from './utils';
import { prefix } from './constants';

type TApiFunction<TPayload = any, TResponse = any> = (
  payload: TPayload,
) => Promise<TResponse>;

export const getHashtagTableList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagDetails: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/details`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagTrendTimeline: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/trend_timelines`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagCountryDistribution: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/country_distribution`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagDetailsKolList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/kol_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagDetailsVideoList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/video_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getHashtagAISummary: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/summary`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getBilibiliHashtagList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/bilibili/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getXHashtagList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/x/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getDouyinHashtagList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/hashtag/douyin/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
